export const getDifferentPrefixToPath = (route) => {
  if (Array.isArray(route)) {
    return [...route, ...route.map((r) => `/accounts${r}`), ...route.map((r) => `/api/accounts${r}`)];
  }
  return [route, `/accounts${route}`, `/api/accounts${route}`];
};
